module.exports = __webpack_public_path__ + "static/media/rokhanna.ae9f0414.png";